import { IContext } from "@src/context";
import { setupAnnouncement } from "./elements/Announcement";
import { triggerPageViewEvent, setupAnalyticListeners } from "@src/analytics";
import { setupWebConfig } from "@src/utils/webConfig";
import { setInitialAccessUrl } from "@src/utils/initialAccessUrl";
import { replacePhoneLinkWithEnquiryFormOnMobile } from "@src/utils/phoneLink";
import { setupImageErrorCallback } from "@src/utils/imageErrorCallback";
import fetchCardsHelper from "./components/SearchCards/fetchCardsHelper";
import searchDataHelper from "./components/SearchPopup/searchDataHelper";

export function setupGlobal(context: IContext) {
  setupWebConfig(context);
  setupAnnouncement(context);
  setupImageErrorCallback();
  fetchCardsHelper.insertContext(context);
  searchDataHelper.init(context);
  setInitialAccessUrl();
  triggerPageViewEvent(context);
  setupAnalyticListeners(context);
  replacePhoneLinkWithEnquiryFormOnMobile(context);
}
